module.exports = __webpack_public_path__ + "img/virtual_field_trip.8ea13dbb.png";